<template>
  <div>
    <card>
      <div class="row">
        <div class="col-sm-6">
          <div class="form-group has-label">
            <label>Datum</label>
            <el-date-picker
              v-model="date"
              format="dd.MM.yyyy"
              value-format="yyyy-MM-dd"
              @change="fetchData"
              :clearable="false"
              :picker-options="{ firstDayOfWeek: 1 }"
            />
          </div>
          <div class="form-group has-label"
            v-if="warehouses.length > 1"
          >
            <warehouse-select
              v-model="warehouse"
              :options="warehouses"
              @input="fetchData"
              :allow-empty="false"
            />
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12">
          <table class="table table-striped table-bordered">
            <thead>
              <tr>
                <th width="50px">&nbsp;</th>
                <th>Produkt</th>
                <th>Inventur</th>
                <th>Lagerstand</th>
                <th>Differenz</th>
                <th></th>
              </tr>
            </thead>
            <transition name="el-fade-in-linear">
              <tbody v-if="!loading">
                <tr v-for="stockRotation in sortedStockRotations" :key="stockRotation.id"
                  :class="stockRotation.wasCorrected ? 'was-corrected' : ''"
                >
                  <td>
                    <span v-if="stockRotation.inventur_quantity != stockRotation.lager_quantity">
                      <i class="fas fa-exclamation-circle text-danger fa-lg"></i>
                    </span>
                  </td>
                  <td>
                    <router-link :to="`/products/${stockRotation.product_instance.product.id}`">
                      #{{ stockRotation.product_instance.id }}: {{ stockRotation.product_instance.product.name }} <span v-if="stockRotation.product_instance.product.is_variation_of">({{ stockRotation.product_instance.product.stringRepShort.join(' | ') }})</span>
                    </router-link>
                  </td>
                  <td class="text-right">
                    <a href="#" @click.prevent="showStockRotationsForProduct(stockRotation.product_instance, true)"
                      v-text="stockRotation.inventur_quantity"
                    ></a>
                  </td>
                  <td class="text-right">
                    <a href="#" @click.prevent="showStockRotationsForProduct(stockRotation.product_instance)"
                      v-text="stockRotation.lager_quantity"
                    ></a>
                  </td>
                  <td class="text-right">{{ stockRotation.inventur_quantity - stockRotation.lager_quantity }}</td>
                  <td>
                    <span v-if="(stockRotation.inventur_quantity != stockRotation.lager_quantity && ! stockRotation.wasCorrected)"
                    >
                      <a href="#" @click.prevent="ausgleichen(stockRotation)">
                        <i class="fas fa-exchange-alt"></i>
                        Beheben
                      </a>
                    </span>
                  </td>
                </tr>
                <tr v-if="!stockRotations.length">
                  <td colspan="7" style="display: table-cell;">Keine Inventur für diesen Tag gefunden.</td>
                </tr>
              </tbody>
            </transition>
          </table>
        </div>
      </div>
    </card>
    <product-stock-rotations-dialog
      :show="showProductStockRotations"
      :stock-rotations="productStockRotations"
      @close="showProductStockRotations = false"
    />
  </div>
</template>

<script>
import ProductStockRotationsDialog from './product-stock-rotations-dialog'
import { DatePicker } from 'element-ui'
import WarehouseSelect from 'src/components/warehouse-select.vue'
import moment from 'moment'

export default {
  props: [],
  components: {
    ProductStockRotationsDialog,
    [DatePicker.name]: DatePicker,
    WarehouseSelect
  },
  data () {
    return {
      date: moment().format('YYYY-MM-DD'),
      stockRotations: [],
      showProductStockRotations: false,
      productStockRotations: [],
      warehouse: null,
      warehouses: [],
      loading: true
    }
  },
  methods: {
    showStockRotationsForProduct (product, onlyInventory = false) {
      this.$http.get(`/product_instances/${product.id}/stock_rotations?date=${this.date}&warehouse=${this.warehouse.id}${onlyInventory ? '&only_inventory=1' : ''}`).then(({ data }) => {
        this.productStockRotations = data
        this.showProductStockRotations = true
      })
    },
    fetchData () {
      this.loading = true
      const date = this.date || moment().format('YYYY-MM-DD')
      this.$http.get(`inventory?date=${date}&warehouse=${this.warehouse.id}`).then(({ data }) => {
        this.stockRotations = data.map(sr => {
          sr.wasCorrected = false
          return sr
        })
        this.loading = false
      })
    },
    ausgleichen (stockRotation) {
      const quantity = Math.abs(stockRotation.inventur_quantity - stockRotation.lager_quantity)
      const type = +stockRotation.inventur_quantity > +stockRotation.lager_quantity ? 'korrekturaufbuchung' : 'schwund'

      const reqData = {
        quantity,
        warehouse_id: this.warehouse.id
      }

      const preMessage = this.filterIsToday ? '' : 'Achtung, der Lagerstand wird mit heutigem Datum korrigiert, um nachvollziehbarkeit zu gewährleisten, der Lagerstand in dieser Ansicht wird daher weiterhin als nicht mit der Inventur übereinstimmend angezeig. '
      const confirmMessage = `${preMessage}${type} mit Menge ${quantity} erfassen?`

      if (confirm(confirmMessage)) {
        this.$http.post(`/product_instances/${stockRotation.product_instance.id}/stock_rotations/${type}`, reqData).then(({ data }) => {
          if (this.filterIsToday) {
            if (type === 'korrekturaufbuchung') {
              stockRotation.lager_quantity = +stockRotation.lager_quantity + quantity
            } else {
              stockRotation.lager_quantity = +stockRotation.lager_quantity - quantity
            }
          } else {
            stockRotation.wasCorrected = true
          }
          this.$notify({
            message: `${type} erfolgreich erstellt.`,
            type: 'success'
          })
        })
      }
    }
  },
  computed: {
    filterIsToday () {
      return this.date === moment().format('YYYY-MM-DD')
    },
    sortedStockRotations () {
      return [...this.stockRotations].sort((srA, srB) => {
        const aHasErrro = srA.inventur_quantity !== srA.lager_quantity
        const bHasError = srB.inventur_quantity !== srB.lager_quantity
        return (aHasErrro === bHasError) ? 0 : aHasErrro ? -1 : 1
      })
    }
  },
  created () {
    this.$http.get('/warehouses').then(({ data }) => {
      this.warehouses = data
      if (data.length) {
        this.warehouse = this.$store.state.filters.warehouse || data[0]
        this.fetchData()
      }
    })
  }
}
</script>

<style type="text/css">
  .was-corrected {
    opacity: 0.5;
  }
</style>
